import React, { useState, useEffect, useRef } from "react";
import {
    Checkbox,
    Dialog,
    DialogActions,
    Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import AlertTriangle from "../../../../assets/svg/routing/alert-triangle.svg";
import CustomButton from "../../../reusableComponents/CustomButton";
import ReactQuill from "react-quill";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { extractTextFromHTML } from "../../utils/utils";
import ContentHeader from "../../../reusableComponents/contentHeader/ContentHeader";
import { useParams } from "react-router-dom";


function RollbackModal({ modalData, setModalData, getFilteredData }) {
    const { revertReconFile } = useAuth();
    const [reason, setReason] = useState("");
    const [loader, setLoader] = useState(false);
    const [dataLength, setDataLength] = useState(0);
    const [initialLoaded, setInitialLoaded] = useState(false);
    const [isQuillFocused, setIsQuillFocused] = useState(false);
    const { reconId } = useParams();


    const handleKeyDownFallback = (event) => {
        if (event.key === "Escape") {
            setModalData(null);
        }
    };

    const modules = {
        toolbar: [
            [], [], []
        ],
    };

    const handleRevertFile = () => {
        setLoader(true);
        const payload = reason ? { reason: extractTextFromHTML(reason) } : {};
        revertReconFile(
            modalData,
            reconId,
            payload,
            function (res) {
                customToast("success", "high", "File Reverted Successfully");
                getFilteredData();
                setModalData(null)
                setLoader(false);
            },
            function (errMsg) {
                setLoader(false);
                customToast("error", "high", errMsg);
            }
        );
    };

    const handleChange = (data) => {
        const formattedData = extractTextFromHTML(data);
        if (formattedData?.length > 5 && !initialLoaded) setInitialLoaded(true);
        if (formattedData?.length >= 200) {
            setDataLength(formattedData.length);
            return;
        }
        setDataLength(formattedData.length);
        setReason(data);
    };

    return (
        <Dialog
            open={Boolean(modalData)}
            PaperProps={{
                style: {
                    backgroundColor: "#FFF",
                    borderRadius: "12px",
                    width: "750px",
                    maxWidth: "750px",
                },
            }}
            onKeyDown={handleKeyDownFallback}>
            <div>
                <div
                    className="d-flex align-items-start w-100 justify-content-between"
                    style={{ padding: "24px 24px 0px 24px" }}
                >
                    <div className="d-flex align-items-start w-100 justify-content-between" style={{ gap: "10px" }}>
                        <AlertTriangle />
                        <ContentHeader
                            firstHeading="Please provide a reason for Rollback "
                            secondHeading="You're about to rollback this document. Please provide a reason for this action. This will help maintain transparency and track changes."
                        />
                    </div>
                    <Close style={{ cursor: "pointer" }} onClick={() => setModalData(null)} />
                </div >

                <div className="px-4 mt-2">
                    <Typography className="offerDetailsFieldTitle">
                        Add reason for Rollback *
                    </Typography>
                    <ReactQuill
                        theme="snow"
                        value={reason}
                        onChange={handleChange}
                        modules={modules}
                        onFocus={() => setIsQuillFocused(true)}
                        onBlur={() => setIsQuillFocused(false)}
                        className="richTextEditior"
                        placeholder="For e.g. Insufficient information, does not meet eligibility criteria."
                        style={{
                            borderColor: dataLength < 3 && initialLoaded ? "rgb(211, 47, 47)" : isQuillFocused ? "#58C6BC" : null,
                            transition: "border-color 0.3s ease",
                        }}
                    />
                    <p style={{ textAlign: "end", color: "#7F7D83" }}>{dataLength}/200</p>
                </div>
            </div >

            <div className="modalBottomBar mt-2" style={{ boxShadow: "none" }}>
                <CustomButton
                    text="cancel"
                    onClick={() => setModalData(null)}
                    disabled={dataLength < 3 || loader}
                    variant="outlined"
                    type="secondary"
                />
                <CustomButton
                    loading={loader}
                    text="Rollback"
                    onClick={handleRevertFile}
                    disabled={dataLength < 3}
                    variant="contained"
                    type="secondary"
                />
            </div>
        </Dialog >
    );
}

export default RollbackModal;